var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDividerLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 300,
    viewBox: "0 0 1920 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "divider-light"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_490_625",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 300
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1920 300V0L0 0V300L1920 300Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_490_625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1920 0H0V300H1920V0Z",
    fill: "url(#paint0_radial_490_625)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sun"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.2,
    d: "M1332.43 660.277C1235.1 569.503 983.162 343.358 827.191 283.292C630.67 207.608 264.073 114.162 225.104 76.714C186.127 39.2704 249.313 -28.8023 192.386 -91.3174C139.622 -149.264 -215.145 -368.016 -381.77 -419.131C-493.602 -449.411 -488.025 -335.121 -460.946 -317.38C-360.605 -291.501 -10.5213 -194.854 78.3735 -84.8433C182.464 43.9777 52.3259 23.0295 136.664 102.836C221.003 182.642 805.205 311.546 980.642 427.455C1107.16 511.039 1247.41 624.734 1315.8 681.649C1351.33 704.92 1360.27 685.394 1332.43 660.277Z",
    fill: "#F5E0B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.35,
    d: "M653.252 -60.1583C685.949 -50.3488 734.221 -36.1322 790.706 -20.3329C896.284 9.19674 1039.42 -10.4977 1116.86 -28.9792C1194.3 -47.4607 1363.12 -23.5109 1451.35 36.3916C1539.57 96.2967 1565.28 219.33 1642.52 298.168C1693.01 349.701 1814.98 413.633 1893.43 451.745L1944.13 275.144C1878.7 253.257 1783.55 206.836 1711.58 115.634C1681.94 78.0763 1649.39 44.0908 1615.42 13.9819C1435.54 -112.536 1324.73 -142.897 1110.86 -128.971C1033.66 -116.437 958.694 -98.4034 909.41 -85.9151C841.363 -68.6724 728.709 -89.9849 666.031 -104.67C583.598 -112.272 569.635 -82.9666 653.252 -60.1583Z",
    fill: "#F5E0B7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    opacity: 0.03,
    d: "M1406.33 534.466C1523.12 576.809 1652.12 516.458 1694.47 399.669C1736.81 282.879 1676.47 153.875 1559.67 111.531C1442.88 69.1875 1313.88 129.538 1271.53 246.329C1229.18 363.118 1289.54 492.121 1406.33 534.466Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M1645.89 323.497C1645.89 413.169 1573.2 485.86 1483.53 485.86C1393.86 485.86 1321.17 413.169 1321.17 323.497C1321.17 233.829 1393.86 161.138 1483.53 161.138C1573.2 161.138 1645.89 233.829 1645.89 323.497Z",
    fill: "#F9C041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    opacity: 0.03,
    d: "M1414.73 511.349C1518.75 549.063 1633.65 495.311 1671.37 391.29C1709.08 287.27 1655.32 172.371 1551.3 134.657C1447.29 96.9429 1332.39 150.694 1294.67 254.716C1256.96 358.736 1310.71 473.635 1414.73 511.349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M1645.88 323.502C1645.88 278.429 1627.51 237.648 1597.85 208.23C1581.97 261.313 1517.27 434.274 1351.88 418.549C1381.38 459.327 1429.34 485.864 1483.52 485.864C1573.19 485.864 1645.88 413.173 1645.88 323.502Z",
    fill: "#F7941E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.4,
    d: "M1506.34 241.722C1506.34 276.593 1478.07 304.862 1443.2 304.862C1408.33 304.862 1380.06 276.593 1380.06 241.722C1380.06 206.849 1408.33 178.581 1443.2 178.581C1478.07 178.581 1506.34 206.849 1506.34 241.722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.4,
    d: "M1415.55 279.608C1415.55 295.219 1402.9 307.872 1387.29 307.872C1371.67 307.872 1359.02 295.219 1359.02 279.608C1359.02 263.998 1371.67 251.347 1387.29 251.347C1402.9 251.347 1415.55 263.998 1415.55 279.608Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "constellations"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M180.127 229.075L180.504 228.658L183.012 230.906L182.636 231.322L180.127 229.075ZM65.015 295.689L64.8901 295.144L68.1832 294.399L68.308 294.944L65.015 295.689ZM70.3391 293.102L70.6435 289.759L71.2045 289.81L70.9001 293.152L70.3391 293.102ZM58.4297 297.182L58.3041 296.638L61.5964 295.892L61.722 296.436L58.4297 297.182ZM175.11 224.58L175.486 224.164L177.995 226.411L177.618 226.827L175.11 224.58ZM51.8429 298.675L51.718 298.13L55.0103 297.384L55.1352 297.929L51.8429 298.675ZM70.9478 286.418L71.2522 283.076L71.8132 283.127L71.5089 286.469L70.9478 286.418ZM45.2575 300.167L45.1327 299.622L48.425 298.876L48.5499 299.422L45.2575 300.167ZM38.6708 301.66L38.5459 301.115L41.8382 300.369L41.9632 300.914L38.6708 301.66ZM32.0855 303.153L31.9598 302.609L35.2529 301.862L35.3778 302.407L32.0855 303.153ZM170.092 220.087L170.469 219.671L172.978 221.918L172.602 222.334L170.092 220.087ZM71.5565 279.735L71.8602 276.394L72.4212 276.444L72.1176 279.786L71.5565 279.735ZM25.4987 304.646L25.3738 304.101L28.6661 303.355L28.7911 303.9L25.4987 304.646ZM18.9134 306.138L18.7878 305.594L22.0801 304.848L22.2057 305.392L18.9134 306.138ZM12.3266 307.631L12.201 307.087L15.4941 306.34L15.619 306.885L12.3266 307.631ZM72.1639 273.052L72.4675 269.71L73.0286 269.761L72.7248 273.102L72.1639 273.052ZM165.075 215.593L165.452 215.177L167.96 217.424L167.584 217.84L165.075 215.593ZM8.22708 308.56L6.51427 306.207L6.97098 305.879L8.46489 307.932L8.90868 307.831L9.0343 308.376L8.22708 308.56ZM72.7726 266.369L73.0769 263.026L73.6379 263.077L73.3336 266.419L72.7726 266.369ZM160.058 211.1L160.434 210.684L162.942 212.931L162.566 213.347L160.058 211.1ZM2.55594 300.771L3.01265 300.442L4.99219 303.161L4.53549 303.489L2.55594 300.771ZM73.3806 259.686L73.6849 256.344L74.246 256.394L73.9416 259.737L73.3806 259.686ZM155.041 206.607L155.418 206.191L157.926 208.438L157.55 208.854L155.041 206.607ZM-1.40383 295.333L-0.947134 295.004L1.03242 297.723L0.575699 298.051L-1.40383 295.333ZM73.99 253.002L74.2937 249.66L74.8547 249.711L74.551 253.053L73.99 253.002ZM150.024 202.114L150.4 201.698L152.91 203.944L152.533 204.36L150.024 202.114ZM75.1433 246.361L77.8373 244.337L78.1769 244.782L75.4836 246.807L75.1433 246.361ZM-5.36217 289.896L-4.90546 289.568L-2.92592 292.286L-3.38262 292.615L-5.36217 289.896ZM80.53 242.313L83.2233 240.288L83.5629 240.734L80.8695 242.758L80.53 242.313ZM85.9166 238.263L88.6099 236.239L88.9495 236.684L86.2561 238.709L85.9166 238.263ZM91.3039 234.215L93.998 232.191L94.3375 232.636L91.6442 234.661L91.3039 234.215ZM61.5665 249.934L61.4973 249.379L64.4682 249.014L64.5374 249.569L61.5665 249.934ZM96.6912 230.166L99.3846 228.141L99.7241 228.587L97.0308 230.612L96.6912 230.166ZM102.078 226.117L104.771 224.092L105.111 224.538L102.417 226.562L102.078 226.117ZM145.006 197.619L145.383 197.203L147.892 199.451L147.515 199.867L145.006 197.619ZM107.465 222.068L110.159 220.044L110.499 220.49L107.805 222.514L107.465 222.068ZM112.853 218.019L115.546 215.995L115.885 216.44L113.192 218.465L112.853 218.019ZM54.8633 250.76L54.794 250.205L58.146 249.792L58.2152 250.347L54.8633 250.76ZM118.24 213.971L120.933 211.946L121.273 212.392L118.579 214.416L118.24 213.971ZM-9.32124 284.459L-8.86452 284.131L-6.885 286.849L-7.3417 287.178L-9.32124 284.459ZM123.626 209.921L126.32 207.897L126.659 208.342L123.966 210.367L123.626 209.921ZM129.014 205.873L131.708 203.849L132.047 204.294L129.353 206.318L129.014 205.873ZM48.1586 251.584L48.0894 251.029L51.4413 250.617L51.5106 251.172L48.1586 251.584ZM134.401 201.824L137.094 199.799L137.434 200.245L134.741 202.27L134.401 201.824ZM139.788 197.775L142.482 195.751L142.821 196.196L140.128 198.221L139.788 197.775ZM41.4554 252.409L41.3861 251.854L44.7374 251.442L44.8066 251.997L41.4554 252.409ZM-13.2803 279.022L-12.8236 278.693L-10.844 281.412L-11.3 281.74L-13.2803 279.022ZM34.7514 253.234L34.6822 252.679L38.0341 252.266L38.1034 252.822L34.7514 253.234ZM28.0468 254.06L27.9776 253.505L31.3295 253.092L31.3987 253.648L28.0468 254.06ZM21.3428 254.885L21.2736 254.33L24.6255 253.918L24.6948 254.473L21.3428 254.885ZM-17.2393 273.584L-16.7826 273.256L-14.8038 275.974L-15.2598 276.302L-17.2393 273.584ZM14.6396 255.71L14.5704 255.155L17.9216 254.743L17.9908 255.298L14.6396 255.71ZM7.93566 256.535L7.86638 255.98L11.2184 255.567L11.2876 256.123L7.93566 256.535ZM-21.1977 268.146L-20.741 267.818L-18.7615 270.537L-19.2175 270.864L-21.1977 268.146ZM1.231 257.361L1.16177 256.806L4.51373 256.393L4.58296 256.949L1.231 257.361ZM-5.47294 258.187L-5.5422 257.631L-2.1902 257.219L-2.12097 257.774L-5.47294 258.187ZM-12.1769 259.012L-12.2461 258.457L-8.89417 258.044L-8.82494 258.599L-12.1769 259.012ZM-25.1568 262.709L-24.7001 262.381L-22.7205 265.099L-23.1772 265.428L-25.1568 262.709ZM-18.8809 259.836L-18.9501 259.28L-15.5981 258.868L-15.5289 259.423L-18.8809 259.836ZM-25.5841 260.662L-25.6533 260.106L-22.3014 259.694L-22.2321 260.249L-25.5841 260.662Z",
    fill: "#08000C"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M65.843 295.215C66.4337 297.785 69.0089 299.393 71.5961 298.806C74.1827 298.22 75.8021 295.661 75.2114 293.091C74.6213 290.522 72.0455 288.913 69.4582 289.5C66.8717 290.087 65.253 292.645 65.843 295.215Z",
    fill: "#08000C"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M64.3946 248.819C65.3739 253.081 69.6474 255.749 73.9386 254.776C78.2297 253.804 80.9149 249.559 79.9363 245.296C78.9577 241.032 74.6849 238.365 70.3924 239.338C66.1012 240.311 63.4154 244.556 64.3946 248.819Z",
    fill: "#08000C"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M138.477 196.652C139.067 199.222 141.643 200.83 144.23 200.244C146.818 199.657 148.436 197.099 147.846 194.529C147.256 191.959 144.68 190.35 142.093 190.937C139.506 191.523 137.886 194.082 138.477 196.652Z",
    fill: "#08000C"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M173.344 230.691C174.458 235.543 179.322 238.579 184.206 237.472C189.09 236.365 192.147 231.534 191.033 226.682C189.919 221.83 185.055 218.794 180.171 219.901C175.287 221.008 172.23 225.839 173.344 230.691Z",
    fill: "#08000C"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    opacity: 0.42
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M1884.14 107.141L1884.17 107.316L1883.1 107.469L1883.07 107.293L1884.14 107.141ZM1884.78 111.556L1885.39 115.796L1884.32 115.948L1883.71 111.708L1884.78 111.556ZM1886 120.034L1886.61 124.274L1885.54 124.426L1884.93 120.187L1886 120.034ZM1887.22 128.513L1887.83 132.752L1886.77 132.905L1886.16 128.665L1887.22 128.513ZM1888.44 136.992L1889.06 141.233L1887.99 141.385L1887.38 137.144L1888.44 136.992ZM1889.67 145.471L1890.09 148.406L1890.45 149.594L1889.42 149.898L1889.04 148.635L1888.6 145.624L1889.67 145.471ZM1891.68 153.699L1892.91 157.804L1891.87 158.109L1890.65 154.004L1891.68 153.699ZM1894.14 161.91L1895.36 166.015L1894.33 166.32L1893.1 162.214L1894.14 161.91ZM1896.59 170.12L1897.82 174.225L1896.78 174.53L1895.56 170.425L1896.59 170.12ZM1899.05 178.331L1900.27 182.436L1899.24 182.741L1898.01 178.635L1899.05 178.331ZM1902.24 186.082L1904.42 189.777L1903.49 190.318L1901.31 186.623L1902.24 186.082ZM1906.6 193.472L1908.78 197.167L1907.85 197.709L1905.67 194.014L1906.6 193.472ZM1910.96 200.863L1913.14 204.558L1912.21 205.1L1910.03 201.405L1910.96 200.863ZM1915.32 208.253L1917.5 211.949L1916.57 212.49L1914.39 208.796L1915.32 208.253ZM1919.68 215.644L1921.86 219.339L1920.93 219.88L1918.75 216.185L1919.68 215.644ZM1919.01 218.023L1918.46 218.945L1914.75 216.767L1915.3 215.845L1919.01 218.023ZM1911.58 213.669L1911.04 214.591L1907.32 212.413L1907.87 211.491L1911.58 213.669ZM1904.16 209.313L1903.61 210.235L1899.9 208.057L1900.45 207.135L1904.16 209.313ZM1896.73 204.958L1896.19 205.88L1892.48 203.704L1893.02 202.782L1896.73 204.958ZM1889.31 200.603L1888.76 201.525L1885.05 199.347L1885.6 198.425L1889.31 200.603ZM1881.88 196.248L1881.34 197.17L1880.76 196.832L1877.42 195.667L1877.78 194.66L1881.21 195.867L1881.88 196.248ZM1873.72 193.228L1873.36 194.236L1869.29 192.806L1869.65 191.798L1873.72 193.228ZM1865.59 190.367L1865.23 191.375L1861.17 189.945L1861.53 188.937L1865.59 190.367ZM1857.46 187.504L1857.1 188.515L1853.04 187.086L1853.4 186.075L1857.46 187.504ZM1849.34 184.646L1848.98 185.654L1844.91 184.224L1845.27 183.216L1849.34 184.646ZM1841.21 181.785L1840.85 182.793L1836.78 181.363L1837.15 180.355L1841.21 181.785ZM1833.08 178.925L1832.72 179.932L1828.66 178.502L1829.02 177.494L1833.08 178.925Z",
    fill: "#08000C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M1824.21 173.654C1826.98 172.039 1830.55 172.964 1832.17 175.72C1833.8 178.476 1832.87 182.018 1830.09 183.632C1827.32 185.246 1823.75 184.321 1822.13 181.566C1820.5 178.81 1821.44 175.268 1824.21 173.654Z",
    fill: "#08000C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M1878.59 192.293C1880.59 191.124 1883.17 191.794 1884.35 193.787C1885.52 195.781 1884.85 198.344 1882.84 199.511C1880.84 200.679 1878.26 200.01 1877.08 198.016C1875.91 196.023 1876.58 193.461 1878.59 192.293Z",
    fill: "#08000C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M1920.17 215.504C1922.31 214.258 1925.06 214.972 1926.31 217.099C1927.57 219.226 1926.85 221.96 1924.71 223.206C1922.57 224.452 1919.81 223.738 1918.56 221.611C1917.31 219.485 1918.03 216.751 1920.17 215.504Z",
    fill: "#08000C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M1897.8 178.877C1899.62 177.815 1901.97 178.424 1903.03 180.236C1904.1 182.048 1903.49 184.378 1901.67 185.439C1899.84 186.501 1897.5 185.892 1896.43 184.08C1895.36 182.268 1895.97 179.939 1897.8 178.877Z",
    fill: "#08000C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M1885.54 138.616C1888.04 137.158 1891.26 137.993 1892.73 140.482C1894.2 142.97 1893.35 146.17 1890.85 147.627C1888.35 149.085 1885.12 148.25 1883.66 145.761C1882.19 143.273 1883.03 140.074 1885.54 138.616Z",
    fill: "#08000C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M1881.01 104.078C1882.92 102.97 1885.37 103.606 1886.48 105.496C1887.6 107.387 1886.96 109.819 1885.05 110.927C1883.15 112.035 1880.7 111.4 1879.59 109.509C1878.47 107.617 1879.11 105.187 1881.01 104.078Z",
    fill: "#08000C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M27.7835 21.9432L25.0971 22.0798L25.0734 21.6206L27.7598 21.484L27.7835 21.9432ZM22.4114 22.2172L19.725 22.3539L19.7013 21.8946L22.3877 21.7579L22.4114 22.2172ZM17.0392 22.4898L14.3528 22.6264L14.3298 22.1664L17.0162 22.0298L17.0392 22.4898ZM11.6671 22.7638L8.98065 22.9004L8.95771 22.4404L11.6441 22.3038L11.6671 22.7638ZM6.29492 23.0363L3.60857 23.173L3.58484 22.7137L6.27128 22.5771L6.29492 23.0363ZM0.922842 23.3103L-1.76359 23.447L-1.78662 22.9869L0.899807 22.8503L0.922842 23.3103ZM-4.44933 23.5829L-7.13576 23.7195L-7.1594 23.2603L-4.47297 23.1237L-4.44933 23.5829ZM-9.82219 23.8562L-12.5086 23.9928L-12.5323 23.5336L-9.84583 23.3969L-9.82219 23.8562ZM-15.1944 24.1287L-17.8807 24.2655L-17.9044 23.8061L-15.218 23.6695L-15.1944 24.1287Z",
    fill: "#08000C"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M32.0541 21.2651L30.446 21.3474L30.4696 21.8066L31.6221 21.7488L31.6955 22.9009L32.1554 22.8722L32.0541 21.2651Z",
    fill: "#08000C"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M32.4983 28.3209L32.0377 28.3503L31.8657 25.6256L32.3263 25.5963L32.4983 28.3209ZM32.8415 33.7696L32.3816 33.7983L32.2097 31.0736L32.6696 31.045L32.8415 33.7696ZM33.1848 39.2183L32.7242 39.2477L32.5522 36.523L33.0128 36.4937L33.1848 39.2183ZM33.5273 44.6664L33.0674 44.695L32.8954 41.9703L33.356 41.941L33.5273 44.6664ZM33.8706 50.1151L33.4099 50.1444L33.2387 47.4204L33.6986 47.3918L33.8706 50.1151ZM34.2138 55.5638L33.7532 55.5931L33.5812 52.8684L34.0418 52.8391L34.2138 55.5638ZM34.557 61.0125L34.0964 61.0418L33.9252 58.3178L34.3851 58.2892L34.557 61.0125ZM34.9003 66.4612L34.4397 66.4905L34.2677 63.7658L34.7282 63.7364L34.9003 66.4612ZM35.2435 71.9099L34.7836 71.9385L34.6116 69.2138L35.0715 69.1851L35.2435 71.9099Z",
    fill: "#08000C"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M35.4738 74.663L35.0137 74.6922L35.1012 76.0715L35.5614 76.0423L35.4738 74.663Z",
    fill: "#08000C"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M37.6255 24.3652C39.2041 21.169 37.8922 17.2968 34.6953 15.719C31.499 14.1405 27.6269 15.4523 26.0491 18.6493C24.4706 21.8456 25.7823 25.7176 28.9793 27.2954C32.1763 28.8733 36.0477 27.5622 37.6255 24.3652Z",
    fill: "#08000C"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M38.5723 77.6579C39.4721 75.8357 38.7245 73.6283 36.9016 72.7277C35.0794 71.8279 32.8719 72.5755 31.9714 74.3984C31.0715 76.2205 31.8193 78.428 33.6421 79.3286C35.4643 80.2285 37.6717 79.4807 38.5723 77.6579Z",
    fill: "#08000C"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "planet1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M1434.96 189.9C1428.64 238.19 1384.37 272.216 1336.08 265.898C1287.78 259.578 1253.76 215.308 1260.08 167.018C1266.4 118.727 1310.67 84.7014 1358.96 91.0218C1407.25 97.3398 1441.27 141.609 1434.96 189.9Z",
    fill: "#196EA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M1266.63 143.339L1434.71 165.336C1435.9 173.287 1436.04 181.534 1434.95 189.9C1434.55 192.975 1433.99 195.984 1433.29 198.937L1259.36 176.179C1259.44 173.146 1259.67 170.093 1260.07 167.018C1261.17 158.649 1263.43 150.717 1266.63 143.339ZM1267.01 214.463C1270.45 222.134 1274.96 229.264 1280.38 235.633L1397.68 250.98C1404.55 246.223 1410.74 240.49 1416.04 233.963L1267.01 214.463ZM1287.14 114.18C1281.64 119.342 1276.8 125.236 1272.74 131.712L1431.79 152.524C1429.54 145.221 1426.38 138.279 1422.39 131.873L1287.14 114.18ZM1259.76 187.106C1260.16 191.149 1260.82 195.131 1261.75 199.02L1425.08 220.393C1426.99 216.877 1428.66 213.199 1430.08 209.393L1259.76 187.106Z",
    fill: "#27AAE1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    opacity: 0.3,
    d: "M1434.95 189.9C1438.12 165.628 1431.1 142.368 1417.21 124.44C1404.91 151.902 1357.88 240.492 1269.92 220.37C1282.93 244.406 1306.89 262.079 1336.07 265.898C1384.36 272.216 1428.63 238.188 1434.95 189.9Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    opacity: 0.4,
    d: "M1314.02 150.029C1312.92 158.439 1305.21 164.362 1296.8 163.263C1288.39 162.163 1282.47 154.457 1283.57 146.047C1284.67 137.637 1292.38 131.719 1300.79 132.819C1309.19 133.919 1315.12 141.619 1314.02 150.029Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184_2",
    opacity: 0.03,
    d: "M1305.77 292.721C1368.58 315.493 1437.95 283.037 1460.72 220.231C1483.49 157.424 1451.04 88.0486 1388.23 65.2766C1325.42 42.5053 1256.05 74.9606 1233.28 137.768C1210.5 200.574 1242.96 269.949 1305.77 292.721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185_2",
    opacity: 0.03,
    d: "M1311.26 276.481C1365.69 296.216 1425.82 268.089 1445.56 213.656C1465.29 159.224 1437.16 99.0989 1382.73 79.3638C1328.3 59.6287 1268.17 87.756 1248.44 142.189C1228.7 196.621 1256.83 256.746 1311.26 276.481Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "planet2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_184_3",
    opacity: 0.03,
    d: "M481.459 227.932C542.454 250.045 609.819 218.528 631.935 157.538C654.045 96.5478 622.532 29.1794 561.537 7.06615C500.549 -15.0465 433.183 16.47 411.067 77.4604C388.952 138.45 420.471 205.819 481.459 227.932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185_3",
    opacity: 0.03,
    d: "M490.777 200.386C535.976 216.773 585.903 193.418 602.29 148.219C618.678 103.022 595.319 53.0967 550.12 36.7097C504.926 20.3227 454.999 43.6782 438.611 88.8764C422.224 134.074 445.583 183.999 490.777 200.386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M585.222 144.459C570.325 179.659 529.717 196.121 494.513 181.222C459.312 166.328 442.854 125.716 457.75 90.5156C472.646 55.3149 513.258 38.8506 548.459 53.7499C583.666 68.6461 600.118 109.258 585.222 144.459Z",
    fill: "#EF4136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    opacity: 0.3,
    d: "M585.258 144.457C592.747 126.764 592.311 107.7 585.556 91.2238C570.505 109.426 516.364 166.575 454.056 132.928C458.86 153.839 473.28 172.22 494.549 181.22C529.753 196.119 570.362 179.658 585.258 144.457Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    opacity: 0.4,
    d: "M543.982 89.1821C538.191 102.865 522.394 109.271 508.708 103.481C495.013 97.6872 488.616 81.8871 494.407 68.2011C500.2 54.5061 515.994 48.109 529.689 53.9025C543.375 59.696 549.775 75.4901 543.982 89.1821Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_490_625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(960 150) rotate(3.73853) scale(731.557 422.978)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F92E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91A9DB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerLight);
export default __webpack_public_path__ + "static/media/divider-light.b3f6531ab4a236a48106555486d93ba7.svg";
export { ForwardRef as ReactComponent };